import io from "socket.io-client";

class WebSocketService {
  constructor() {
    this.socket = null;
    this.listeners = new Map();
    this.reconnectAttempts = 0;
    this.maxReconnectAttempts = 5;
  }

  connect(userData) {
    const socketUrl =
      process.env.REACT_APP_SOCKET_URL || "http://localhost:5003";

    this.socket = io(socketUrl, {
      transports: ["websocket"],
      reconnection: true,
      reconnectionAttempts: this.maxReconnectAttempts,
      reconnectionDelay: 1000,
    });

    this.socket.on("connect", () => {
      console.log("Connected to WebSocket");
      this.reconnectAttempts = 0;
      this.socket.emit("join", userData);
      this.emit("connected");
    });

    this.socket.on("disconnect", (reason) => {
      console.log("Disconnected from WebSocket:", reason);
      this.emit("disconnected", reason);
    });

    this.socket.on("reconnect_attempt", (attemptNumber) => {
      this.reconnectAttempts = attemptNumber;
      this.emit("reconnecting", attemptNumber);
    });

    this.socket.on("reconnect_failed", () => {
      this.emit("reconnectFailed");
    });

    // Register global event handlers
    this.registerGlobalHandlers();
  }

  registerGlobalHandlers() {
    // Booking changes
    this.socket.on("bookingChange", (data) => {
      this.emit("bookingChange", data);
    });

    // Active users
    this.socket.on("activeUsers", (users) => {
      this.emit("activeUsers", users);
    });

    // Activity metrics
    this.socket.on("activityMetrics", (metrics) => {
      this.emit("activityMetrics", metrics);
    });

    // Critical alerts
    this.socket.on("criticalAlerts", (alerts) => {
      this.emit("criticalAlerts", alerts);
    });

    // User presence
    this.socket.on("userJoinedBooking", (data) => {
      this.emit("userJoinedBooking", data);
    });

    this.socket.on("userLeftBooking", (data) => {
      this.emit("userLeftBooking", data);
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  emit(event, data) {
    if (this.socket && this.socket.connected) {
      this.socket.emit(event, data);
    }

    // Trigger local listeners
    const eventListeners = this.listeners.get(event) || [];
    eventListeners.forEach((callback) => callback(data));
  }

  on(event, callback) {
    if (!this.listeners.has(event)) {
      this.listeners.set(event, []);
    }
    this.listeners.get(event).push(callback);

    // Also register with socket if connected
    if (this.socket) {
      this.socket.on(event, callback);
    }

    // Return unsubscribe function
    return () => {
      const eventListeners = this.listeners.get(event) || [];
      const index = eventListeners.indexOf(callback);
      if (index > -1) {
        eventListeners.splice(index, 1);
      }

      if (this.socket) {
        this.socket.off(event, callback);
      }
    };
  }

  viewBooking(bookingId) {
    this.emit("viewBooking", bookingId);
  }

  leaveBooking(bookingId) {
    this.emit("leaveBooking", bookingId);
  }
}

export default new WebSocketService();
